export default __webpack_public_path__ + "static/media/Member-Default.df72abcd.svg";